// Add class to body-element on tab click

const LazyImage = () => {
  var observer
  const self = {
    init () {
      const $$images = document.querySelectorAll('[data-lg-lazy-src]')
      if ($$images.length < 1) return
      self.initObserver($$images)
    },
    initObserver ($$images) {
      const config = {
        // If the image gets within 50px in the Y axis, start the download.
        rootMargin: '300px 0px',
        threshold: 0.01
      }

      // The observer for the images on the page
      observer = new IntersectionObserver(self.onIntersection, config)
      $$images.forEach($image => {
        observer.observe($image)
      })
    },
    onIntersection (entries) {
      // Loop through the entries
      entries.forEach(entry => {
        // Are we in viewport?
        if (entry.intersectionRatio > 0) {
          // Stop watching and load the image
          observer.unobserve(entry.target)
          entry.target.setAttribute(
            'src',
            entry.target.getAttribute('data-lg-lazy-src')
          )
        }
      })
    }
  }

  return self
}

export default LazyImage
